export const REDUX_STORE_HOME = 'widget_layout'
export const WIDGET_TAB_SELECTED = 'TAB_SELECTED'

export const COMMUNITY_NAME = '__COMMUNITY__'
export const USER_FIRST_NAME = '__FIRST_NAME__'
export const ENABLE_RECAPTCHA_KEY = 'enable_recaptcha_on_signup'
